import { render, staticRenderFns } from "./FluxoCobranca.vue?vue&type=template&id=42968086&scoped=true"
import script from "./FluxoCobranca.vue?vue&type=script&lang=js"
export * from "./FluxoCobranca.vue?vue&type=script&lang=js"
import style0 from "./FluxoCobranca.vue?vue&type=style&index=0&id=42968086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42968086",
  null
  
)

export default component.exports